import {decodeSupplierCode, isEqual} from '~/utils/helpers'
import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useAccommodationRuntimeData(
    route: RouteLocationNormalizedLoaded,
    cityId?: number | string,
    isRefresh = false
) {
    const {cityIdAdapter} = useCustomizationHelpers()
    const cid = cityId || cityIdAdapter(route.query.cityId)
    let {supplierCode} = route.query
    const {cityCode, hotelCode} = route.query
    const hotelId = +route.query.hotelId || hotelsRuntimeStore.routeMap.hotelId || undefined
    if (supplierCode) supplierCode = decodeSupplierCode(supplierCode)
    const hotelInfoRequest = {supplierCode, cityCode, hotelCode, hotelId}

    const promises = []
    if (!isEqual(hotelsRuntimeStore.hotelInfoRequest, hotelInfoRequest) || isRefresh) {
        promises.push(hotelsRuntimeStore.loadHotelInfo(hotelInfoRequest))
    }
    if (hotelsRuntimeStore.city?.id !== cid || isRefresh) {
        promises.push(hotelsRuntimeStore.loadCity(cid))
    }

    await Promise.all(promises)
}
